import UsageTracker from 'FormsUI/utils/UsageTracker';
import { invert } from 'underscore';
import isAcceptanceTest from 'forms-utils-lib/localStorage/isAcceptanceTest';
let lastScreen;
const SCREENS = {
  DASHBOARD: 'dashboard-interaction',
  EDITOR: 'editor-interaction'
};
export const trackEvents = (eventKey, options) => {
  if (!isAcceptanceTest()) {
    UsageTracker.track(eventKey, options);
  }
};
export function trackScreen(screen, subscreen = '', options = {}) {
  lastScreen = SCREENS[screen.toUpperCase()];
  trackEvents('pageView', Object.assign({
    screen,
    subscreen
  }, options));
}
export function trackSubScreen(subscreen = '', options) {
  const screen = (invert(SCREENS)[lastScreen] || '').toLowerCase();
  if (screen) {
    trackScreen(screen, subscreen, options);
  }
}
export function trackDashboardInteraction(action, options = {}) {
  lastScreen = SCREENS.DASHBOARD;
  trackEvents('trackDashboardInteraction', Object.assign({
    action
  }, options));
}
export function trackEditorInteraction(action, options = {}) {
  lastScreen = SCREENS.EDITOR;
  trackEvents('trackEditorInteraction', Object.assign({
    action
  }, options));
}
export function trackEmailInteraction(data) {
  trackEvents('trackEmailSuspensionInteraction', Object.assign({}, data));
}

// used on components reused across different screens
export function trackInteraction(action, options = {}) {
  switch (lastScreen) {
    case SCREENS.DASHBOARD:
      trackDashboardInteraction(action, options);
      break;
    case SCREENS.EDITOR:
      trackEditorInteraction(action, options);
      break;
      break;
    default:
      return;
  }
}
export function trackActivation(action, options = {}) {
  trackEvents('trackDashboardActivation', Object.assign({
    action
  }, options));
}
export function trackUsage(action, options = {}) {
  trackEvents('trackDashboardUsage', Object.assign({
    action
  }, options));
}
export const getFromToValue = (from, to) => [`from:${from}`, `to:${to}`];
export const trackOnPageExitIntent = () => {
  trackEvents('exitPage', {});
};
export const trackReportingAnalyzeTab = () => {
  trackEvents('analyzeView', {
    screen: 'forms',
    subscreen: 'analyze'
  });
};
export const trackClicksMarketingAnalytics = () => {
  trackEvents('exploreAnalyticsSuite', {
    screen: 'forms',
    subscreen: 'analyze'
  });
};